import { Component, ViewChild, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DialogBoxPrintComponentDebidaDiligencia } from "./dialog/dialog-print-box.component";
import { MatTable } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { first } from "rxjs/operators";
import { MatIconModule } from "@angular/material/icon";
import { DebidaDiligenciaService } from "../../services/debida-diligencia.service";
import { DebidaDiligencia } from "app/main/models/debida-diligencia.model";
import { MarcoDeReferenciaService } from "app/main/services/marco-de-referencia.service";
import { MarcoDeReferencia } from "app/main/models/marco-de-referencia.model";
import { getUsuariosNodo } from "app/main/models/nodo-estructura-jerarquica.model";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UsersService } from "../../services/users.service";
import { NodeSelectorDialogBoxComponent } from "app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component";
import { TokenStorageService } from "app/main/auth/token-storage.service";
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators,
} from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { DialogAnalisisBoxPrintComponentDebidaDiligencia } from "./dialog/dialog-analisis-print-box.component";
import { DialogAnalisisBoxAnalyticsComponentDebidaDiligencia } from "./dialog/dialog-analisis-analytics-box.component";
import { UtilsService } from "../../services/utils.service";
import { FormularioService } from "app/main/services/formulario.service";
import { DialogBoxCambioEstadoComponent } from "./dialog/dialog-box-cambio-estado.component";

@Component({
    selector: "debida-diligencia-external-view",
    templateUrl: "./debida-diligencia-external-view.component.html",
    styleUrls: ["./debida-diligencia-external-view.component.scss"],
})
export class DebidaDiligenciaViewExternalComponent {
    displayedColumns: string[] = ["nombre", "descripcion", "respuesta"];
    debidaDiligencia: DebidaDiligencia = null;
    selectedStatus: number;
    isEditable = false;
    isReseted = false;

    isFormularioEnviado = false;

    uuid: string = null;
    formId: string = null;
    is_eval_creador: boolean = false;
    is_responsable: boolean = false;

    editar_nombre: boolean = false;
    editar_estado: boolean = false;
    editar_tabla_de_evaluacion: boolean = false;
    editar_estructura: boolean = false;
    editar_marco_de_referencia: boolean = false;
    editar_responsable: boolean = false;
    editar_fecha_fin: boolean = false;
    nombre: string = "";

    estados: any[] = ["INICIADO", "COMPLETADO", "CERRADO"];

    marcosDeReferencia = [];
    estructuraJerarquicas = [];
    tablasDeEvaluacion = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];

    preiniciadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    iniciadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    completadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    aprobadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    cerradoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });

    isThisStepDone0 = false;
    isThisStepDone1 = false;
    isThisStepDone2 = false;
    isStepDone0 = "";
    isStepDone1 = "";
    isStepDone2 = "";

    selectedIndex = null;
    role = null;
    is_eval_owner = false;
    is_admin = false;

    fechaFin = null;
    editar_dueno = true;
    tipo = "DEBIDA_DILIGENCIA";

    @ViewChild("stepper") private stepper: MatStepper;

    //@ViewChild("stepper") stepper: MatStepper;

    constructor(
        public dialog: MatDialog,
        private storage: TokenStorageService,
        private service: DebidaDiligenciaService,
        private serviceFormularioService: FormularioService,
        public serviceMarcoDeReferenciaService: MarcoDeReferenciaService,
        private _snackBar: MatSnackBar,
        public translate: TranslateService,
        public router: Router,
        public utils: UtilsService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.uuid = params.get("uuid");

            // this.service.getByUUID(this.uuid).pipe().subscribe(req => {
            //   this.debidaDiligencia = new DebidaDiligencia(req.body);

            //   this.debidaDiligencia.formulario.sentencias  = [...this.debidaDiligencia.formulario.sentencias];
            //   this.orderStructure(this.debidaDiligencia.formulario.sentencias);
            //   this.loadEvalData();
            // });

            this.formId = params.get("id");

            this.service
                .getFormByUUIDAndId(this.uuid, this.formId)
                .pipe()
                .subscribe((req) => {
                    this.debidaDiligencia = new DebidaDiligencia(req.body);

                    this.debidaDiligencia.formulario.sentencias = [
                        ...this.debidaDiligencia.formulario.sentencias,
                    ];
                    this.orderStructure(
                        this.debidaDiligencia.formulario.sentencias
                    );
                    this.loadEvalData();
                });
        });
    }

    loadEvalData() {
        var user = this.storage.getUser();
        this.role = this.storage.getRole();
        this.setActiveStep();

        this.is_responsable = true;

        this.fechaFin = this.debidaDiligencia.fechaVencimiento;

        if (this.role != undefined && this.role.includes(2))
            this.is_admin = true;

        console.log("SENTENCIAS");
        console.log(this.debidaDiligencia?.formulario?.sentencias);
    }

    print(): void {
        const dialogRef = this.dialog.open(
            DialogAnalisisBoxPrintComponentDebidaDiligencia,
            {
                panelClass: "my-full-screen-dialog",
                width: "95%",
                maxWidth: "95%",
                data: { action: "Print", obj: this.debidaDiligencia },
                autoFocus: false,
            }
        );
    }

    save(): void {
        this.isFormularioEnviado = true;

        this.serviceFormularioService
            .closeFormStatus(this.debidaDiligencia.formulario.id)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.formulario.estado = "COMPLETADO";
                    this.setActiveStep();
                    this.openSnackBar(
                        "Se modificó el estado de la operación a completado.",
                        "Cerrar"
                    );
                },
                (err) => {
                    this.openSnackBar(
                        "No se pudo modificar el estado, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    viewStatistics(sentencias, nivel, esMatrizReverso): void {
        //DialogAnalisisBoxPrintComponentdebidaDiligencia
        const dialogRef = this.dialog.open(
            DialogAnalisisBoxAnalyticsComponentDebidaDiligencia,
            {
                panelClass: "my-full-screen-dialog",
                width: "95%",
                maxWidth: "95%",
                height: "95%",
                maxHeight: "95%",
                data: {
                    action: "Print",
                    obj: sentencias,
                    nivel: nivel,
                    esMatrizReverso: esMatrizReverso,
                },
                autoFocus: false,
                disableClose: true,
            }
        );
    }

    navegateTo(url, id): void {
        this.router.navigateByUrl(url).then((e) => {
            if (e) {
                console.log("Navigation is successful!");
            } else {
                console.log("Navigation has failed!");
            }
        });
    }

    selectEstado(): void {
        this.editar_estado = false;
    }

    selectRespuesta(sentencia, respuesta): void {
        this.service
            .addRespuesta(
                this.debidaDiligencia.UUID,
                sentencia.id,
                respuesta.value
            )
            .pipe()
            .subscribe(
                (req) => {},
                (err) => {
                    this.openSnackBar(
                        "No se pudo registrar la respuesta, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    changeStatus(): void {
        var ss = this.selectedStatus;
        var status = "";
        if (
            ss == 0 &&
            this.is_responsable &&
            this.debidaDiligencia.estado == "INICIADO"
        ) {
            status = "COMPLETADO";
        }
        if (
            ss == 1 &&
            this.is_eval_creador &&
            this.debidaDiligencia.estado == "COMPLETADO"
        ) {
            status = "CERRADO";
        }

        if (status != "") {
            const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
                width: "100%",
                data: { action: status },
                disableClose: true,
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result.event != "Cancel") {
                    this.service
                        .editStatus(this.debidaDiligencia.id, status)
                        .pipe()
                        .subscribe(
                            (req) => {
                                this.debidaDiligencia.estado = status;
                                this.setActiveStep();
                                this.openSnackBar(
                                    "Se modificó el estado de la operacion a " +
                                        status,
                                    "Cerrar"
                                );
                            },
                            (err) => {
                                this.openSnackBar(
                                    "No se pudo modificar el estado, ocurrió un error.",
                                    "Cerrar"
                                );
                            }
                        );
                } else {
                    this.setActiveStep();
                }
            });
        }
    }

    setIndex(event) {
        this.selectedIndex = event.selectedIndex;
    }

    setActiveStep(): void {
        this.isThisStepDone0 = false;
        this.isThisStepDone1 = false;
        this.isThisStepDone2 = false;
        this.isStepDone0 = "";
        this.isStepDone1 = "";
        this.isStepDone2 = "";

        if (this.debidaDiligencia.estado == "INICIADO") {
            this.selectedStatus = 0;
        }
        if (this.debidaDiligencia.estado == "COMPLETADO") {
            this.isThisStepDone0 = false;
            this.isStepDone0 = "done";
            this.selectedStatus = 1;
        }
        if (this.debidaDiligencia.estado == "CERRADO") {
            this.isThisStepDone0 = false;
            this.isStepDone0 = "done";
            this.isThisStepDone1 = false;
            this.isStepDone1 = "done";
            this.selectedStatus = 2;
        }

        if (this.stepper != null) {
            this.stepper.linear = false;
            this.stepper.selectedIndex = this.selectedStatus;
            setTimeout(() => {
                this.stepper.linear = true;
            });
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    compareObjects(o1: any, o2: any): boolean {
        var equals = false;
        if (o1 != null && o2 != null)
            equals = o1.nombre === o2.nombre && o1.id === o2.id;
        return equals;
    }

    esEvaluadorGroup(usuario): boolean {
        var esEvaluador: boolean = false;

        usuario.tipos.forEach((element) => {
            if (element.id == 7) esEvaluador = true;
        });

        return esEvaluador;
    }

    orderStructure(nodos): void {
        for (var z = 0; nodos.length > z; z++) {
            nodos.sort(this.utils.sortAlphaNum);
            //nodos.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
            this.orderStructure(nodos[z].sentencias);
        }
    }

    selectDueno(owner): void {
        this.editar_dueno = false;

        this.service
            .editResponsable(this.debidaDiligencia.id, owner.value)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.responsable = owner.value;
                    this.editar_responsable = false;
                    //window.location.reload();
                },
                (err) => {
                    this.openSnackBar(
                        "No se pudo modificar el dueño, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    updateData(): void {
        this.debidaDiligencia.formulario.sentencias = [
            ...this.debidaDiligencia.formulario.sentencias,
        ];
    }
}
